// © Microsoft Corporation. All rights reserved.

import { SubscribableMap } from "@msnews/js-extensions";

export const cookieManagementState = new SubscribableMap<CookieManagementState, any>("CookieManagementState");

export enum CookieManagementState {
    // Stores whether the cookie state has been initialized or not
    Initialized = 1,
    // Stores the type of provider used to provide consent for cookies. E.g.: MSCC banner, OneTrust banner or None
    CookieConsentProvider,
    // Stores the cookie consent status. E.g.: Required, NotRequired or Unknown
    CookieConsentStatus,
    // Stores the active cookie categories that are allowed to be written when using the `trySetCookie()` function
    ActiveCookieCategories
}